import { Navigate } from 'react-router-dom';

type Props = {
  requiredRoles: Array<string>;
  userRoles: string;
  element: JSX.Element;
};
const ProtectedRoute: React.FC<Props> = ({
  requiredRoles,
  userRoles,
  element,
}: Props) => {
  const isAuthorized =
    requiredRoles?.length == 0 ||
    requiredRoles.some((role) => userRoles == role);
  const isAdmin = userRoles.includes('ADMIN');
  return isAdmin || isAuthorized ? (
    element
  ) : (
    <Navigate to="/" replace />
  );
};

export default ProtectedRoute;
